import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import {
  useSetUserPlanNotes,
  type AdminUser,
} from "@/hooks/useAdminUsers";

interface Props {
  user: AdminUser | null;
  open: boolean;
  onClose: () => void;
}

export function PlanNotesDialog({ user, open, onClose }: Props) {
  const setNotes = useSetUserPlanNotes();
  const [value, setValue] = useState("");

  useEffect(() => {
    if (open && user) {
      setValue(user.plan_notes ?? "");
    }
  }, [open, user?.id, user?.plan_notes]);

  function handleSave() {
    if (!user) return;
    const trimmed = value.trim();
    setNotes.mutate({
      userId: user.id,
      planNotes: trimmed === "" ? null : trimmed,
    });
    onClose();
  }

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Plan notes</DialogTitle>
          <DialogDescription>
            {user
              ? `Internal admin notes about ${user.email}'s plan. Only visible to admins.`
              : ""}
          </DialogDescription>
        </DialogHeader>

        <Textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="e.g. Comped 2026-04 — early beta tester"
          rows={5}
        />

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={!user}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default PlanNotesDialog;
